
export default function ResumeButton() {
    return (
        <a href="https://portfolio-assets-2.storage.googleapis.com/resume.pdf" target="_blank">
            <button className="resume-button">My Resume</button>
        </a>
    )
}